<template>
  <section>
    <PageTitle title="Nasza oferta" />
    <div
      class="container px-4 mx-auto text-center sm:px-0 lg:px-0 xl:px-0 2xl:px-64 md:pt-40 lg:pt-40 2xl:pt-56 sm:text-left"
    >
      <main>
        <div class="text-center divide-y divide-gray-200 min-h-1/2"></div>
        <section class="text-gray-700 body-font">
          <div class="container mx-auto">
            <div
              class="flex flex-col items-center pb-10 mx-auto mb-10 border-b border-gray-200 lg:w-4/5 sm:flex-row"
            >
              <div
                class="inline-flex items-center justify-center flex-shrink-0 order-first w-20 h-20 rounded-full sm:w-32 sm:order-none sm:h-32 sm:ml-10 bg-primary-100 text-primary-500"
              >
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-10 h-10 sm:w-16 sm:h-16"
                  viewBox="0 0 24 24"
                >
                  <circle cx="6" cy="6" r="3" />
                  <circle cx="6" cy="18" r="3" />
                  <path d="M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12" />
                </svg>
              </div>
              <div class="flex-grow mt-6 text-center sm:text-left sm:mt-0">
                <h2 class="mb-2 text-3xl font-bold text-primary title-font">Haft</h2>
                <div class="text-base leading-relaxed">
                  <p>
                    Dostarczamy profesjonalne rozwiązania dla firm, klubów sportowych oraz osób pragnących stworzyć własne linie odzieżowe oparte o haft.
                    Wykonujemy
                    <strong>hafty klasyczne</strong> oraz
                    <strong>3D na półproduktach (wykrojach) oraz produktach gotowych:</strong>
                  </p>
                  <ul class="p-4 list-disc list-inside">
                    <li>odzieży roboczej, przemysłowej, jksportowej,</li>
                    <li>koszulkach, t-shirtach, bluzach, spodniach,</li>
                    <li>kurtkach, softshellach, polarach,</li>
                    <li>czapkach, szalach, rękawiczkach,</li>
                    <li>torbach, plecakach,</li>
                    <li>ręcznikach, pościelach,</li>
                    <li>flagach, banerach, chorągwiach, proporczykach.</li>
                  </ul>
                  <p>
                    Wykonujemy także różnego rodzaju haftowane emblematy: podklejane, podszywane rzepem lub na guzik.
                    <br />
                    <strong>Stosujemy tylko wysokiej jakości materiały</strong>pomocnicze w postaci flizelin, hydrofolii oraz filców hafciarskich w różnej kolorystyce.
                    Cena każdej usługi uzgadniana jest indywidualnie z klientem. Na wycenę haftu wpływają:
                  </p>

                  <ul class="p-4 list-disc list-inside">
                    <li>materiał na którym haft ma być wykonany,</li>
                    <li>wielkość haftu,</li>
                    <li>ilość wykonywanych haftów,</li>
                    <li>termin wykonania.</li>
                  </ul>

                  <p class="font-bold">
                    Realizację rozpoczynamy po otrzymaniu akceptu przesłanej wizualizacji z wzorem
                    cyfrowym od naszego studia projektowego oraz dostarczenia towaru.
                  </p>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col items-center pb-10 mx-auto mb-10 border-b border-gray-200 lg:w-4/5 sm:flex-row"
            >
              <div
                class="inline-flex items-center justify-center flex-shrink-0 order-first w-20 h-20 rounded-full sm:w-32 sm:order-none sm:h-32 sm:ml-10 bg-primary-100 text-primary-500"
              >
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-10 h-10 sm:w-16 sm:h-16"
                  viewBox="0 0 24 24"
                >
                  <circle cx="6" cy="6" r="3" />
                  <circle cx="6" cy="18" r="3" />
                  <path d="M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12" />
                </svg>
              </div>
              <div class="flex-grow mt-6 text-center sm:text-left sm:mt-0">
                <h2 class="mb-2 text-3xl font-bold text-primary title-font">Laser</h2>
                <div class="text-base leading-relaxed">
                  W zakres usług laserowych oferowanych przez naszą firmę wchodzą:
                  <ul class="p-4 list-disc list-inside">
                    <li>grawerowanie i znakowanie artykułów reklamowych, przemysłowych i użytku domowego,</li>
                    <li>precyzyjne wycinanie tekstu, znaków graficznych oraz innych wzorów z papieru, filcu, drewna, tworzyw sztucznych, pleksi czy laminatu.</li>
                  </ul>
                  <strong>Przy ustalaniu ceny istotne są: wielkość, materiał oraz zlecana ilość.</strong>
                </div>
              </div>
            </div>
            <div class="flex flex-col items-center mx-auto lg:w-4/5 sm:flex-row">
              <div
                class="inline-flex items-center justify-center flex-shrink-0 order-first w-20 h-20 rounded-full sm:w-32 sm:order-none sm:h-32 sm:ml-10 bg-primary-100 text-primary-500"
              >
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-10 h-10 sm:w-16 sm:h-16"
                  viewBox="0 0 24 24"
                >
                  <circle cx="6" cy="6" r="3" />
                  <circle cx="6" cy="18" r="3" />
                  <path d="M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12" />
                </svg>
              </div>
              <div class="flex-grow mt-6 text-center sm:text-left sm:mt-0">
                <h2 class="mb-2 text-3xl font-bold text-primary title-font">Usługi projektowe</h2>
                <p class="pb-2">
                  Firma dzięki
                  <strong>własnemu studiu projektowania haftu komputerowego</strong>oferuje możliwość opracowywania wzorów cyfrowych (hafciarskich) także innym hafciarniom.
                </p>
                <p class="pb-2">
                  Nasi projektanci pracują na
                  <strong>najnowszym oprogramowaniu WILCOM EmbroideryStudio e3</strong>, który dobierając najlepsze parametry ściegu, kierunek wyłożenia nitki oraz kolejności haftowania obiektów ulepsza proces produkcji i zmniejsza zużycie materiału oraz energii poprzez eliminacje błędów.
                </p>
              </div>
            </div>
            <button
              class="flex px-8 py-2 mx-auto mt-20 text-lg text-white border-0 rounded bg-primary-500 focus:outline-none hover:bg-primary-600"
            >Button</button>
          </div>
        </section>
        <div class="hidden">
          <Faq />
        </div>
      </main>
    </div>
  </section>
</template>

<script>
import PageTitle from "../components/PageTitle";
import Faq from "../components/Faq";
export default {
  name: "About",
  components: {
    PageTitle,
    Faq,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
